import {postData} from "./api.service";
import { appInsights } from "../../core/services/insight.service";

export const fetchReportSummary = async (reportSummaryRequest: any) => {
    try{
    const response =await postData('ReportsSummary/summary-report-acct', reportSummaryRequest);
    return response;
    }
    catch(error :any)
    {
      appInsights.trackEvent({ name: "FetchReportSummaryFailed", properties: { error: error } });
    }
    
}